<div class="rules-condition-selectors">
  <!-- variable list -->
  <div class="variable-conditions">
    <ng-container *ngIf="currentCondition else nocurrentcondition">
      <!-- <div *ngIf="currentCondition.values.length == 0 || currentCondition.options.length == 0"> Fix call for {{currentCondition.key}} </div> -->
      <div class="condition-select">
        <settings-rules-rule-form-helper-select
          [options]="availableConditions"
          [optionSelected]="currentCondition.key"
          (actionSelect)="selectVariable($event)"
        ></settings-rules-rule-form-helper-select>
      </div>  
      <div class="condition-select-small">
        <settings-rules-rule-form-helper-select
          [options]="currentCondition.options"
          [optionSelected]="currentRuleCondition.condition"
          (actionSelect)="selectOption($event)"
        ></settings-rules-rule-form-helper-select>
      </div>
        <div class="condition-search" *ngIf="CONDITION_LABELS_SEARCHABLE_KEYS.includes(currentCondition.key) else defaultselector">
          <!-- TODO oct-2023: DEFINE WHAT keys use either seach component or simple selector comp for specific keys -->
          <settings-rules-rule-form-helper-search-main 
            [term]="term"
            [found]="found"
            [variable]="currentCondition"
            [result]="currentRuleCondition.value"
            [multipleValues]="false"
            (termChanges)="onSetTerm($event)"
            (removeFilter)="onRemove($event)"
            (selectedChanges)="onSelectValue($event)"
          ></settings-rules-rule-form-helper-search-main>
        </div>

        <ng-template  #defaultselector>
          <div class="condition-select">
            <settings-rules-rule-form-helper-select
            [options]="currentCondition.values"
            [optionSelected]="currentRuleCondition.value.toString()"
            (actionSelect)="onSelectValue([$event])"
            ></settings-rules-rule-form-helper-select>
          </div>
        </ng-template>
    </ng-container>
    <ng-template #nocurrentcondition> 
        <div class="loader">
          <div class="dimmed">
            <div class="dimmed_flex">
              <div class="dimmed_box dimmed_middle"></div>
              <div class="dimmed_box dimmed_middle"></div>
              <div class="dimmed_box"></div>
            </div>
          </div>
        </div>
    </ng-template> 
  </div>
  
  <div class="button-conditions-add">
    <core-helpers-forms-button-icon [text]="'Add condition'" [icon]="'add'" (click)="addCondition()" ></core-helpers-forms-button-icon>
    <span class="action" (click)="removeCondition()">Remove</span>
  </div>
</div>
